import { FC } from 'react';

import { SubHeading } from 'src/components';
import { Flex } from 'src/components/Flex';

import { TextDisplay } from '../TextDisplay';

interface AccountDisplay {
    heading: string;
    bic: string;
    iban: string;
    accountName: string;
    ukBankDetails?: {
        sortCode: string;
        accountNumber: string;
        bankName: string;
        branch: string;
        addressLine1: string;
        addressLine2: string;
        town: string;
        postCode: string;
    };
}

const AccountDisplay: FC<AccountDisplay> = ({ bic, iban, accountName, heading, ukBankDetails }) => {
    return (
        <>
            <SubHeading subHeading={heading} />

            {bic && iban && (
                <Flex justifyContent="space-between">
                    <TextDisplay label="BIC" value={bic} />
                    <TextDisplay label="IBAN" value={iban} />
                </Flex>
            )}

            <TextDisplay label="Account Name" value={accountName} />

            {ukBankDetails && (
                <>
                    <Flex justifyContent="space-between">
                        <TextDisplay label="Sort Code" value={ukBankDetails.sortCode} />
                        <TextDisplay label="Account Number" value={ukBankDetails.accountNumber} />
                    </Flex>
                    <Flex justifyContent="space-between">
                        <TextDisplay label="Bank Name" value={ukBankDetails.bankName} />
                        <TextDisplay label="Branch" value={ukBankDetails.branch} />
                    </Flex>
                    <Flex justifyContent="space-between">
                        <TextDisplay label="Address Line 1" value={ukBankDetails.addressLine1} />
                        <TextDisplay label="Address Line 2" value={ukBankDetails.addressLine2} />
                    </Flex>
                    <Flex justifyContent="space-between">
                        <TextDisplay label="Town" value={ukBankDetails.town} />
                        <TextDisplay label="Post Code" value={ukBankDetails.postCode} />
                    </Flex>
                </>
            )}
        </>
    );
};

export default AccountDisplay;
